export default "__VITE_ASSET__DC9uSOJU__"